import angular from "angular";
import uiRouter from "angular-ui-router";
import eventdropdownsidebarComponent from "./eventdropdownsidebar.component";

let eventdropdownsidebarModule = angular
  .module("eventdropdownsidebar", [uiRouter])

  .component("eventdropdownsidebar", eventdropdownsidebarComponent);

export default eventdropdownsidebarModule;



// WEBPACK FOOTER //
// ./client/app/common/eventdropdownsidebar/eventdropdownsidebar.js